import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const CoverSection = () => (
  <View id="7">
    <Text bold size="small">
      7. METODOLOGIA
    </Text>

    <Separator weight={4} />

    <Text>
      A redação dada pela Portaria 3.751, de 23/11/1990, à NR-17 - ERGONOMIA estabelece os parâmetros para avaliar a
      adaptação das condições de trabalho às características psicofisiológicas dos trabalhadores, e que cabe ao
      empregador realizar a AET, devendo ela abordar, no mínimo, as condições de trabalho conforme estabelecido na NR
      que são as seguintes:
    </Text>

    <ul>
      <li>
        <Text>Levantamento, transporte e descarga individual de materiais (item 17.5);</Text>
      </li>

      <li>
        <Text>Mobiliário dos Postos de Trabalho (item 17.6);</Text>
      </li>

      <li>
        <Text>Trabalho com máquinas, equipamentos e ferramentas manuais (item 17.7);</Text>
      </li>

      <li>
        <Text>
          Condições Ambientais de Trabalho, onde são executadas atividades que exijam manutenção da solicitação
          intelectual e atenção constantes, devem ser adotadas medidas de conforto acústico e de conforto térmico (item
          17.8.4);
        </Text>
      </li>

      <li>
        <Text>Organização do Trabalho e aspectos cognitivos (item 17.4.1 itens a à f e 17.4.3);</Text>
      </li>
    </ul>

    <Text>
      Foi realizado a Análise Ergonômicas Preliminar (AEP), em cumprimento ao item 17.3.1, e a partir dos possíveis
      agentes de risco, aprofundou-se o estudo contemplando:
    </Text>

    <ul>
      <li>
        <Text>Identificação da faixa etária da população da empresa;</Text>
      </li>

      <li>
        <Text>Distribuição setorial dos colaboradores da empresa;</Text>
      </li>

      <li>
        <Text>
          Observações das atividades reais de trabalho, entrevistas e levantamento da percepção dos funcionários;
        </Text>
      </li>

      <li>
        <Text>
          Levantamento qualitativo dimensional do posto de trabalho (altura dos monitores/notebooks, teclados, mouse,
          cadeiras, etc.);
        </Text>
      </li>

      <li>
        <Text>
          Levantamento dos tipos de regulagem praticado no posto de trabalho, do tempo médio de uso de sistemas
          informatizados durante a jornada de trabalho;
        </Text>
      </li>
    </ul>

    <Separator weight={8} />

    <Text bold size="small">
      7.2. AVALIAÇÃO QUANTITATIVA
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      7.2.1. RUÍDO
    </Text>

    <Separator weight={4} />

    <Text>
      Realizada a medição de ruído, através de leitura com medidor de nível de pressão sonora, operando no circuito de
      compensação “A”, e medidos no circuito de resposta lenta (slow). Foi utilizado este procedimento para avaliar
      fontes de ruído, as estações de trabalho e o ambiente de trabalho geral dos colaboradores
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      7.2.2 ILUMINÂNCIA
    </Text>

    <Separator weight={4} />

    <Text>
      Realizada a avaliação quantitativa dos níveis de iluminamento a fim de verificar se os níveis medidos atendem
      normatização pertinente, utilizando como parâmetro técnico a Norma Regulamentadora NR-17, aprovada pela Portaria
      no 3.214/78 da Secretaria do Trabalho – STRAB. Comparado com valores estabelecidos pela NHO 11 (Norma de Higiene
      Ocupacional) – Avaliação dos níveis de iluminamento em ambientes internos de trabalho, para iluminamento em
      conformidade com o item 17.5.3.3 da NR 17.
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      7.2.3 TEMPERATURA E UMIDADE
    </Text>

    <Separator weight={4} />

    <Text>
      A temperatura e umidade relativa foi verificada através de leitura direta com um termo-higrômetro. O termômetro
      foi alinhado segundo um plano horizontal onde a altura de montagem dos equipamentos coincide com a região mais
      atingida do corpo ou a uma altura do tórax do trabalhador exposto, com no mínimo três leituras; com uma leitura
      final, sendo a média destas.
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      7.2.4 VELOCIDADE DO VENTO
    </Text>

    <Separator weight={4} />

    <Text>
      A velocidade do vento foi verificada através de leitura direta com anemômetro. O anemômetro foi alinhado segundo
      um plano horizontal onde a altura de montagem do equipamento coincide com a região mais atingida do corpo ou a uma
      altura onde pode ocorrer a exposição, sendo feita uma leitura; com uma leitura final, sendo a média destas.
    </Text>

    <Separator weight={8} />
  </View>
)

export default CoverSection
